import "./App.css";
import React, {useState,useEffect} from "react"
import { BrowserRouter as Router, Routes, Route, } from "react-router-dom";
import AppBar from "./Components/AppBar/AppBar";
import Footer from "./Components/Footer";
import Login from "./Components/sign-in/sign-in";
import ExecDirectory from "./Pages/Executive/executiveDirectory";
import Register from "./Components/Sign-up/sign-Up";
import Create from "./Pages/Candidate/Create";
import Dashboard from "./Pages/Dashboard/dashboard";
import UsersPage from "./Pages/Users/UsersPage";
import CandidateList from "./Pages/Candidate/candidateList";
import SenateHome from "./Pages/Senate/senateHome";
import SenateVotes from "./Pages/Senate/senateVotes";
import ExecutiveVotes from "./Pages/Executive/votes";
import ResultPage from "./Pages/Results/results";

function App() {
  const [isLoggedIn, setLoggedIn] = useState(false)
  const [user, setUser]= useState({})
  useEffect(() => {
    setToken()
    setUserDetails()
  }, [isLoggedIn]);


  const setUserDetails = () => {
    let userDetails = localStorage.getItem("user")
    setUser(JSON.parse(userDetails))
}
  const setToken = ()=> {
    let token = localStorage.getItem("user_token")
     if (token !==null) {
       setLoggedIn(true)
     }
   }
  const logout = () => {
    localStorage.removeItem("user_token")
    localStorage.removeItem("user")
    setLoggedIn(false)
}
  
  return (
    <Router>
      <AppBar isLoggedIn={isLoggedIn} logout={logout}/>
      <div className="App">
        <Routes>
         <Route path="/" element={<Dashboard user={ user}isLoggedIn={isLoggedIn} />}></Route>
          <Route exact path="/login" element={<Login isLoggedIn={isLoggedIn} setToken={setLoggedIn} />}></Route>
          <Route exact path="/register" element={<Register isLoggedIn={isLoggedIn} setToken={setLoggedIn} />}></Route>
          <Route exact path="/users" element={<UsersPage user={user} isLoggedIn={isLoggedIn} setToken={setLoggedIn} />}></Route>
          <Route exact path="/dashboard" element={<Dashboard user={ user}isLoggedIn={isLoggedIn} />}></Route>
          {/* <Route exact path="/senate" element={<Senate isLoggedIn ={isLoggedIn} />}></Route> */}
          <Route exact path="/executives" element={<ExecDirectory isLoggedIn={isLoggedIn} user={user} />}></Route>
          <Route exact path="/electionresultsreal" element={<ResultPage user={user} isLoggedIn={isLoggedIn }/>}></Route>
          <Route path="/executives/:level/:userId" element={<ExecutiveVotes isLoggedin={isLoggedIn}user={user} />}></Route> 
          <Route exact path="/candidate/create" element={<Create user={user} isLoggedIn={isLoggedIn} />}></Route>
          <Route exact path="/candidate/list" element={<CandidateList user={user} isLoggedIn={isLoggedIn} />}></Route>
          <Route exact path="/senate"     element={<SenateHome user={user} isLoggedIn/>}></Route>
          <Route path="/senate/:level/:userId" element={<SenateVotes user={user} isLoggedIn={isLoggedIn} />}></Route>  
        </Routes>
      </div>
      <Footer />
    </Router>
  );
}

export default App;
